app.controller("EditUserController", ["$scope", "$uibModalInstance", "StaticData", "toastr", "Users", "user",
    function ($scope, $uibModalInstance, StaticData, toastr, Users, user) {
        $scope.format = "dd-MM-yyyy";
        $scope.popup1 = {
            opened: false
        };
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            maxDate: new Date(),
            startingDay: 1
        };
        user.birthDate = new Date(Date.parse(user.birthDate));
        $scope.user = user;
        var oldPhoneNumber = user.phone;

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.genders = [{name: "სქესი"}].concat(gender);
        });

        StaticData.getItemsByKey("citizens").then(function (citizens) {
            $scope.citizenships = [{name: ""}].concat(citizens);
        });

        $scope.update = function () {
            if(!$scope.user.email){
                toastr.error('', 'გთხოვთ მიუთითოთ ელ.ფოსტა');
            } else if(!$scope.user.firstName){
                toastr.error('', 'გთხოვთ მიუთითოთ სახელი');
            } else if(!$scope.user.lastName){
                toastr.error('', 'გთხოვთ მიუთითოთ გვარი');
            } else if(!$scope.user.citizenship){
                toastr.error('', 'გთხოვთ მიუთითოთ მოქალაქეობა');
            } else if(!$scope.user.personalNo){
                toastr.error('', 'გთხოვთ მიუთითოთ პირადი ნომერი');
            }  else if($scope.user.citizenship === 'georgian' && ($scope.user.personalNo.length !== 11 || isNaN($scope.user.personalNo) === true)){
                toastr.error('', 'გთხოვთ სწორად მიუთითოთ პირადი ნომერი');
            } else if(!$scope.user.birthDate){
                toastr.error('', 'გთხოვთ მიუთითოთ დაბადების თარიღი');
            } else if(!$scope.user.gender){
                toastr.error('', 'გთხოვთ მიუთითოთ სქესი');
            } else if(!$scope.user.phone){
                toastr.error('', 'გთხოვთ მიუთითოთ ტელეფონის ნომერი');
            } else {
                if(user.phone != oldPhoneNumber) {
                    if(user.userConfig) user.userConfig.verifiedPhone = false;
                    else user.userConfig = {'verifiedPhone' : false}
                }

                Users.update(user).then(function (resp) {
                    toastr.success('', 'მომხმარებელი რედაქტირებულია');
                    $uibModalInstance.close();
                }).catch(function (err) {
                    if(err) {
                        if(err&&err.data === 'INVALID_EMAIL_FORMAT') {
                            toastr.error('', 'მეილის ფორმატი არასწორია.');
                        }
                        if(err&&err.data === 'Email Already Exists') {
                            toastr.error('', 'მომხმარებელი ასეთი ელ.ფოსტით უკვე არსებობს.');
                        }
                    }
                });
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
